import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23da6ba5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "loading-text" }, "Carregando...", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "row justify-content-center pt-5 gx-5",
  ref: "sectionMain"
}
const _hoisted_6 = { class: "row d-flex flex-column" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Selecione o modo de visualização:", -1))
const _hoisted_8 = { class: "d-lg-flex d-md-flex d-sm-inline justify-content-between align-items-center" }
const _hoisted_9 = { class: "d-flex" }
const _hoisted_10 = { class: "average-container first" }
const _hoisted_11 = { class: "labels-container" }
const _hoisted_12 = { class: "label1-container" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-nowrap" }, "Valor de M²:", -1))
const _hoisted_14 = { class: "highligth text-nowrap" }
const _hoisted_15 = { class: "label2-container" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-nowrap" }, "Área das unidades:", -1))
const _hoisted_17 = { class: "highligth text-nowrap" }
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center pb-5 pt-2\" data-v-23da6ba5><div class=\"group-legend-container\" data-v-23da6ba5><span class=\"circle1\" data-v-23da6ba5></span><span class=\"legend-text\" data-v-23da6ba5>Apartamento</span></div><div class=\"group-legend-container\" data-v-23da6ba5><span class=\"circle2\" data-v-23da6ba5></span><span class=\"legend-text-disabled\" data-v-23da6ba5>Casa</span></div><div class=\"group-legend-container\" data-v-23da6ba5><span class=\"circle3\" data-v-23da6ba5></span><span class=\"legend-text-disabled\" data-v-23da6ba5>Terreno</span></div><div class=\"group-legend-container\" data-v-23da6ba5><span class=\"circle4\" data-v-23da6ba5></span><span class=\"legend-text-disabled\" data-v-23da6ba5>Sala/Loja</span></div></div>", 1)
const _hoisted_19 = { class: "row section-content d-lg-flex d-md-block justify-content-around" }
const _hoisted_20 = { class: "col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 d-flex flex-column" }
const _hoisted_21 = {
  key: 1,
  class: "warning"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Não existem dados com esses filtros para mostrar o mapa. Recarregue a página!", -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 d-flex flex-column justify-content-between" }
const _hoisted_25 = { class: "section-graph" }
const _hoisted_26 = { class: "col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 d-flex flex-column justify-content-between first" }
const _hoisted_27 = {
  class: "row",
  style: {"padding":"0 1.5rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Map = _resolveComponent("Map")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_responsive_table = _resolveComponent("responsive-table")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("header", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: _normalizeClass([
              'custom-button',
              { 'selected-button': _ctx.selectedButton === 1 },
            ]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectButton(1)))
              }, " Raio ", 2),
              _createElementVNode("button", {
                class: _normalizeClass([
              'custom-button',
              { 'selected-button': _ctx.selectedButton === 2 },
            ]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectButton(2)))
              }, " Bairro ", 2),
              _createElementVNode("button", {
                class: _normalizeClass([
              'custom-button',
              { 'selected-button': _ctx.selectedButton === 3 },
            ]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectButton(3)))
              }, " Lançamentos ", 2),
              _createElementVNode("button", {
                class: _normalizeClass([
              'custom-button',
            ]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearFilters()))
              }, " Limpar ")
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                class: _normalizeClass([
              'custom-button-board',
              { 'selected-button-board': _ctx.selectedButtonBoard },
            ])
              }, " MÉDIA ", 2),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("span", _hoisted_14, "R$ " + _toDisplayString(_ctx.formatNumber(_ctx.completeOpportunity.mercado_info.valor_m2)), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formatNumber(_ctx.completeOpportunity.mercado_info.area_media)) + "m²", 1)
                ])
              ])
            ])
          ])
        ]),
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            (_ctx.completeOpportunity.mercado_info.center != null)
              ? (_openBlock(), _createBlock(_component_Map, {
                  key: 0,
                  latLonList: _ctx.latLngList,
                  "center-lat": _ctx.completeOpportunity.mercado_info.center[0],
                  "center-lng": _ctx.completeOpportunity.mercado_info.center[1],
                  zoom: 15
                }, null, 8, ["latLonList", "center-lat", "center-lng"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_apexchart, {
                height: "100%",
                width: "100%",
                options: _ctx.chartOptions,
                series: _ctx.series,
                onDataPointSelection: _ctx.handleDataPointSelectionMeters,
                ref: "chartMeters",
                allowMultipleDataPointsSelection: true
              }, null, 8, ["options", "series", "onDataPointSelection"])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tablesColumn3Area1, (table, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createVNode(_component_responsive_table, {
                  tableTitle: table.title,
                  tableHeaders: table.headers,
                  tableData: table.data,
                  heatMapColors: table.info,
                  pointColor: table.circleColor,
                  showHeatMap: true,
                  isPermittedSelected: true,
                  opportunityList: table.info,
                  tableMaxHeight: '180px',
                  hasFilterClick: true,
                  isBlockedOpportunity: _ctx.isBlockedOpportunity,
                  onLctsCardTableItemSelected: _ctx.handleItemSelectedMeters,
                  onLctsCardTableItemDesselected: _ctx.handleItemDesselectedMeters
                }, null, 8, ["tableTitle", "tableHeaders", "tableData", "heatMapColors", "pointColor", "opportunityList", "isBlockedOpportunity", "onLctsCardTableItemSelected", "onLctsCardTableItemDesselected"])
              ]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tablesColumn3Area2, (table, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createVNode(_component_responsive_table, {
                  tableTitle: table.title,
                  tableHeaders: table.headers,
                  tableData: table.data,
                  heatMapColors: table.info,
                  pointColor: table.circleColor,
                  showHeatMap: true,
                  isPermittedSelected: true,
                  opportunityList: table.info,
                  tableMaxHeight: '180px',
                  hasFilterClick: true,
                  isBlockedOpportunity: _ctx.isBlockedOpportunity,
                  onLctsCardTableItemSelected: _ctx.handleItemSelectedValues,
                  onLctsCardTableItemDesselected: _ctx.handleItemDesselectedValues
                }, null, 8, ["tableTitle", "tableHeaders", "tableData", "heatMapColors", "pointColor", "opportunityList", "isBlockedOpportunity", "onLctsCardTableItemSelected", "onLctsCardTableItemDesselected"])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tablesColumn1Area1, (table, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createVNode(_component_responsive_table, {
                tableTitle: table.title,
                tableHeaders: table.headers,
                tableData: table.data,
                heatMapColors: table.info,
                pointColor: table.circleColor,
                showHeatMap: true,
                showPagination: true,
                stripedTable: true,
                opportunityList: table.info,
                noContainerClass: true,
                isBlockedOpportunity: _ctx.isBlockedOpportunity,
                onLctsCardTableItemSelected: _ctx.handleItemSelectedMeters,
                onLctsCardTableItemDesselected: _ctx.handleItemDesselectedMeters
              }, null, 8, ["tableTitle", "tableHeaders", "tableData", "heatMapColors", "pointColor", "opportunityList", "isBlockedOpportunity", "onLctsCardTableItemSelected", "onLctsCardTableItemDesselected"])
            ]))
          }), 128))
        ])
      ], 512))
}